<template>
    <div class="navMobile">
        <div class="navbutton" @click="show = !show">
            <i class="el-icon-menu"></i>
        </div>
        <transition name="fadeText">
            <el-col :span="12" class="navlist" v-if="show">
                <el-menu
                    default-active="2"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose"
                >
                    <el-menu-item index="1">
                        <i class="el-icon-menu"></i>
                        <span slot="title" @click="goSport()">運 動 服</span>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <i class="el-icon-menu"></i>
                        <span slot="title" @click="goUniform()">校 園 制 服</span>
                    </el-menu-item>
                    <el-menu-item index="3">
                        <i class="el-icon-menu"></i>
                        <span slot="title" @click="goOther()">書 包</span>
                    </el-menu-item>
                    <el-menu-item index="4">
                        <i class="el-icon-menu"></i>
                        <span slot="title" @click="goOther()">帽 子</span>
                    </el-menu-item>
                    <el-submenu index="5">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span>其 他 產 品</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="1-1" @click="goMask()">口 罩</el-menu-item>
                            <el-menu-item index="1-2" @click="goOther()">圍 兜</el-menu-item>
                            <el-menu-item index="1-2" @click="goOther()">圍 裙</el-menu-item>
                        </el-menu-item-group>
                        <el-submenu index="1-4">
                            <template slot="title">床上用品</template>
                            <el-menu-item index="1-4-1">枕頭套</el-menu-item>
                            <el-menu-item index="1-4-1">床墊套</el-menu-item>
                        </el-submenu>
                    </el-submenu>
                </el-menu>
            </el-col>
        </transition>
    </div>
</template>

<script>

  export default {
    name: 'navbarMobile',
    data() {
      return {
        show: false
      };
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      goSport() {
        document.getElementById('sport').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goUniform() {
        document.getElementById('uniform').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goMask() {
        document.getElementById('MaskInfo').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goBag() {
        document.getElementById('uniform').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goHat() {
        document.getElementById('uniform').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goOther() {
        // document.getElementById('uniform').scrollIntoView();
        alert('即將上市，敬請期待！');
      }
    }

  };

</script>
<style lang='scss' scoped>
    .navMobile {
        .navbutton {
            position: fixed;
            top: 0;
            right: 0;
            padding: 10px;
            z-index: 99;
            i {
                font-size: 2.4rem;
                color: #00a9e0;
            }
        }
        .navlist {
            height: 100vh;
            z-index: 99;
            position: fixed;
            top: 0;
            .el-menu-vertical-demo {
                height: 100vh;
            }
        }
    }

        /* 進入 */
    .fadeText-enter-to, .fadeText-leave {
        opacity: 1;
    }
    /* 過渡 */
    .fadeText-enter-active, .fadeText-leave-active {
        transition: all .3s ease;
    }
    /* 離開 */
    .fadeText-enter, .fadeText-leave-to {
        opacity: 0;
        transform: translateX(10px);
    }

  @media screen and (min-width: 1920px){
    .navMobile {
      display: none;
    }
  }
  @media (min-width:768px) and (max-width:1920px){
    .navMobile {
      display: none;
    }
  }
  @media (min-width:414px) and (max-width:767px){}
  @media (min-width:374px) and (max-width:413px){}
  @media screen and (max-width: 373px){}
</style>



// WEBPACK FOOTER //
// src/components/navbarMobile/index.vue